(() => {
  const init = () => {
    const wraps = document.querySelectorAll("[data-lfdl-description-wrap]");
    wraps.forEach((wrap) => {
      const description = wrap.querySelector("[data-lfdl-description]");
      const toggle = wrap.querySelector("[data-lfdl-toggle]");
      if (!description || !toggle) return;

      const lines = parseInt(description.dataset.lines || "3", 10);
      description.style.setProperty("--lfdl-line-clamp", lines);

      const labelMore = toggle.dataset.labelMore || toggle.textContent.trim();
      const labelLess = toggle.dataset.labelLess || labelMore;

      const refreshToggle = () => {
        const shouldShow = description.scrollHeight > description.clientHeight + 1;
        toggle.hidden = !shouldShow;
      };

      toggle.addEventListener("click", () => {
        const isExpanded = wrap.classList.toggle("is-expanded");
        toggle.setAttribute("aria-expanded", isExpanded ? "true" : "false");
        toggle.textContent = isExpanded ? labelLess : labelMore;
        if (!isExpanded) {
          window.requestAnimationFrame(refreshToggle);
        }
      });

      window.requestAnimationFrame(refreshToggle);
      window.addEventListener("resize", refreshToggle);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
